import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { CreateUserAccountState } from "@TKCCP/Store/Data/CreateUserAccount/CreateUserAccountState";
import { CreateUserAccountModel } from "@TKCCP/Types/ApiModels";
import { Draft } from "immer";

const initialState: CreateUserAccountState = {
    byId: {},
    isLoading: {},
    dataViews: {},
};

const reducer = {
    "Data/CreateUserAccount/BeginLoadCreateUserAccount": (
        draft: Draft<CreateUserAccountState>,
        action: { orderNumber: string },
    ) => {
        draft.isLoading[action.orderNumber] = true;
    },

    "Data/CreateUserAccount/CompleteLoadCreateUserAccount": (
        draft: Draft<CreateUserAccountState>,
        action: { orderNumber: string; model: CreateUserAccountModel | undefined },
    ) => {
        delete draft.isLoading[action.orderNumber];
        if (action.model) {
            draft.byId[action.orderNumber] = action.model;
        }
    },

    "Data/CreateUserAccount/Reset": () => {
        return initialState;
    },
};

const createUserAccountReducer = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).createUserAccount = createUserAccountReducer;
